document.addEventListener("DOMContentLoaded", function() {
  // Function to clear the cart
  function clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function(response) {
      if (response.ok) {
        window.location.reload();
      }
    }).catch(function(error) {
      console.error('Error clearing the cart:', error);
    });
  }

  function checkCartContents() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var products = cart.items;

        // Collect handles of the products in the cart
        var productHandles = products.map(function(product) {
          return product.handle;
        });

        // Determine if the cart only contains 'shipping-insurance' and/or 'premium-gift-packaging'
        var onlyInsuranceAndPackaging = productHandles.every(function(handle) {
          return handle === 'shipping-insurance' || handle === 'premium-gift-packaging';
        });

        // Check if the cart contains at least one of the specific products
        var hasInsurance = productHandles.includes('shipping-insurance');
        var hasPackaging = productHandles.includes('premium-gift-packaging');

        // If the cart only contains the specified products, clear it
        if (onlyInsuranceAndPackaging && (hasInsurance || hasPackaging)) {
          clearCart(); 
        }
      })
      .catch(function(error) {
        console.error('Error fetching the cart contents:', error);
      });
  }

  checkCartContents();

  document.addEventListener('cart:updated', function() {
    checkCartContents(); 
  });
});
